import React from 'react';
import { Button } from 'react-bootstrap';
import { useCheckInLogic } from '../../hooks/useCheckIn';

const CheckInButton: React.FC = () => {
  const { state, handleCheckIn, isCheckInEnabled } = useCheckInLogic();

  return (
    <div className="text-center">
      <Button
        variant="success"
        size="lg"
        disabled={!isCheckInEnabled || state.loading}
        onClick={handleCheckIn}
        className="px-5 py-3"
        style={{
          fontSize: '1.5rem',
          fontWeight: 'bold',
          minWidth: '200px'
        }}
      >
        {state.loading && isCheckInEnabled ? 'Checking In...' : 'Check In'}
      </Button>
    </div>
  );
};

export default CheckInButton;